import $ from 'jquery';
import zipTools from 'components/zip-tools';
import cookies from 'utils/cookies';
import storageUtil from 'utils/storage-util';
import tdaConfig from 'lib/util/tda.config';
import zip from 'lib/util/zip';

var nationalLinks = {
  linkPaths: {
    '#contact-dealer': '/contact-dealer/',
    '#dealers': '/dealers/',
    '#inventory': '/inventory/',
    '#inventoryBtn': '/inventory/',
    '#offers': '/offers/',
    '#offersBtn': '/offers/',
    // '#payment-calculator': 'payment-calculator/',
    '#payment-calculator': '/payment-estimator/',
    '#schedule-a-test-drive': '/schedule-a-test-drive/',
    '#trade-in-value': '/trade-in-value/',
    '#aprOffer': '/offers/?offerType=apr',
    '#cashOffer': '/offers/?offerType=cash',
    '#leaseOffer': '/offers/?offerType=lease',
    '#msrpOffer': '/offers/?offerType=msrp',
    '#multiOffer': '/offers/?offerType=multi',
    '#miscOffer': '/offers/?offerType=misc',
    '#4runner': '/offers/?series=4runner',
    '#4runnerOffers': '/offers/4runner',
    '#86': '/offers/?series=86',
    '#86Offers': '/offers/86/',
    '#avalon': '/offers/?series=avalon',
    '#avalonOffers': '/offers/avalon/',
    '#avalonhybrid': '/offers/?series=avalonhybrid',
    '#avalonhybridOffers': '/offers/avalonhybrid/',
    '#avalonHybrid': '/offers/?series=avalonhybrid',
    '#camry': '/offers/?series=camry',
    '#camryOffers': '/offers/camry/',
    '#camryhybrid': '/offers/?series=camryhybrid',
    '#camryhybridOffers': '/offers/camryhybrid/',
    '#camryHybrid': '/offers/?series=camryhybrid',
    '#chr': '/offers/?series=c-hr',
    '#chrOffers': '/offers/c-hr/',
    '#c-hr': '/offers/?series=c-hr',
    '#c-hrOffers': '/offers/c-hr/',
    '#corolla': '/offers/?series=corolla',
    '#corollaOffers': '/offers/corolla/',
    '#corollaim': '/offers/?series=corollaim',
    '#corollaimOffers': '/offers/corollaim/',
    '#corollaiM': '/offers/?series=corollaim',
    '#corollaHybrid': '/offers/?series=corollahybrid',
    '#corollahybrid': '/offers/?series=corollahybrid',
    '#corollahybridOffers': '/offers/corollahybrid',
    '#corollahatchbackOffers': '/offers/corollahatchback',
    '#highlander': '/offers/?series=highlander',
    '#highlanderOffers': '/offers/highlander/',
    '#highlanderhybrid': '/offers/?series=highlanderhybrid',
    '#highlanderhybridOffers': '/offers/highlanderhybrid/',
    '#highlanderHybrid': '/offers/?series=highlanderhybrid',
    '#landcruiser': '/offers/?series=landcruiser',
    '#landcruiserOffers': '/offers/landcruiser/',
    '#mirai': '/offers/?series=mirai',
    '#prius': '/offers/?series=prius',
    '#priusOffers': '/offers/prius/',
    '#priusc': '/offers/?series=priusc',
    '#priuscOffers': '/offers/priusc/',
    '#priusC': '/offers/?series=priusc',
    '#priusprime': '/offers/?series=priusprime',
    '#priusprimeOffers': '/offers/priusprime/',
    '#priusPrime': '/offers/?series=priusprime',
    '#priusv': '/offers/?series=priusv',
    '#priusvOffers': '/offers/priusv/',
    '#priusV': '/offers/?series=priusv',
    '#rav4': '/offers/?series=rav4',
    '#rav4Offers': '/offers/rav4/',
    '#rav4hybrid': '/offers/?series=rav4hybrid',
    '#rav4hybridOffers': '/offers/rav4hybrid/',
    '#rav4Hybrid': '/offers/?series=rav4hybrid',
    '#sequoia': '/offers/?series=sequoia',
    '#sequoiaOffers': '/offers/sequoia/',
    '#sienna': '/offers/?series=sienna',
    '#siennaOffers': '/offers/sienna/',
    '#tacoma': '/offers/?series=tacoma',
    '#tacomaOffers': '/offers/tacoma/',
    '#tundra': '/offers/?series=tundra',
    '#tundraOffers': '/offers/tundra/',
    '#yaris': '/offers/?series=yaris',
    '#yarisOffers': '/offers/yaris/',
    '#yarisia': '/offers/?series=yarisia',
    '#yarisiaOffers': '/offers/yarisia/',
    '#yarisiA': '/offers/?series=yarisia',
    '#yarishatchbackOffers': '/offers/yarishatchback/',
    '#supraOffers': '/offers/gr-supra/',
    '/home/dealers': '/dealers/'
  },

  linkPaths_404: {
    '#offers': '/offers/',
    '#inventory': '/inventory/'
  },

  init: function (is404) {
    var _this = this;
    var linkpaths = is404 ? _this.linkPaths_404 : _this.linkPaths;
    $.each(linkpaths, function (key, value) {
      $('a[href$="' + key + '"], div[data-url*="' + key + '"]').on('click', function (event) {
        event.preventDefault();
        cookies.removeItem('geoIgnore', '/', cookies.getCrossDomainCookieDomain());
        zipTools.redirectPath = value;
        // Already confirmed zip is unlikely, but possible. User hit back button for example
        if (storageUtil.isConfirmedZip()) {
          if (storageUtil.getTDA() === 'SET10') {
            window.location.href = 'http://buyatoyota.com/southeasttoyota';
          } else {
            zipTools.setInitialZipAndTransfer(zip.getCookiedDefaultFallback());
          }
        } else {
          zipTools.detectZip();
        }
      });
    });

    // BAT-2700 Make Anchors fire onLoad of page not just on click of links
    if (window.location.hash != '') {
      $('a[href$="' + window.location.hash + '"]').trigger('click');
    }

    /*
    BAT-3225: opening the footer links for offers and find a dealer
    in a new tab should redirect if confirmed zip, or open the page
    and pop up the modal if no confirmed zip
    .endsWith added via polyfill to handle IE11
    */

    // offer type footer link (APR, Cash, Lease, MSRP, Specials)
    if (window.location.search.indexOf('offerType=') > -1) {
      if (storageUtil.isConfirmedZip()) {
        // redirect to the TDA site with the correct offer type param
        zipTools.changeZip(undefined, storageUtil.getZip(), '/offers/' + window.location.search, undefined, true);
      } else {
        // if no confirmed zip, remove the geoIgnore cookie and pop up the modal
        cookies.removeItem('geoIgnore', '/', cookies.getCrossDomainCookieDomain());
        zipTools.promptUserForZip(undefined, '/offers/' + window.location.search);
      }
    }

    // View all Offers footer link
    // Same as above, but redirect to the All Offers page on the TDA site
    // Check the hash to ensure this is the footer link and not another #offers link
    if (window.location.href && window.location.href.endsWith('/offers/') && !window.location.hash) {
      if (storageUtil.isConfirmedZip()) {
        // redirect to the TDA site for all offers
        zipTools.changeZip(undefined, storageUtil.getZip(), '/offers/', undefined, true);
      } else {
        // if no confirmed zip, remove the geoIgnore cookie and pop up the modal
        cookies.removeItem('geoIgnore', '/', cookies.getCrossDomainCookieDomain());
        zipTools.promptUserForZip(undefined, '/offers/');
      }
    }

    // Find a Dealer footer link
    // Same as above, but redirect to the dealers page on the TDA site
    if (window.location.href && window.location.href.endsWith('/dealers/') && !window.location.hash) {
      if (storageUtil.isConfirmedZip()) {
        zipTools.changeZip(undefined, storageUtil.getZip(), '/dealers/', undefined, true);
      } else {
        cookies.removeItem('geoIgnore', '/', cookies.getCrossDomainCookieDomain());
        zipTools.promptUserForZip(undefined, '/dealers/');
      }
    }

    // BAT-3424 this is related to BAT-3225, need to include the inventory
    // CTA in the right-click new tab handling as well
    // this if is to make sure we are definately operating on the
    // correct CTA
    if ((window.location.href && window.location.href.indexOf('/inventory/results/'))
      && (window.location.search.indexOf('series=') > -1
      && window.location.search.indexOf('year=') > -1)
      && !window.location.hash) {
      if (storageUtil.isConfirmedZip()) {
        zipTools.changeZip(undefined, storageUtil.getZip(), '/inventory/results/' + window.location.search, undefined, true);
      } else {
        cookies.removeItem('geoIgnore', '/', cookies.getCrossDomainCookieDomain());
        zipTools.promptUserForZip(undefined, '/inventory/results/' + window.location.search);
      }
    }

    var $footerItems = $('ul.js-footer-inventory a, ul.js-footer-offers a, ul.js-footer-dealers a, ul.js-footer-tools a[href$="schedule-a-test-drive/index.page"], ul.js-footer-tools a[href$="contact-dealer/index.page"], ul.js-footer-tools a[href$="payment-estimator/index.page"], ul.js-footer-tools a[href$="trade-in-value/index.page"]');
    $footerItems.on('click', function (event) {
      event.preventDefault();
      var value = $(this).attr('href').replace('/home', '').replace('/es', '');
      // BAT-2353 suppress zip modal until really needed. Here's where we start the zip process for the first time
      cookies.removeItem('geoIgnore', '/', cookies.getCrossDomainCookieDomain());
      zipTools.redirectPath = value;
      // if already confirmed zip (unlikely, but possible. User hit back button maybe, for example)
      if (storageUtil.isConfirmedZip()) {
        zipTools.promptUserForZip(storageUtil.getZip(), zipTools.redirectPath);
      } else {
        zipTools.detectZip();
      }
    });
  }
};

var nationalForms = {
  init: function () {
    var _this = this;
    _this.initOffersForm(); // Where is this used? Answer: on WWW offer-based zip code fields
    // _this.initInventoryForm(); // Where is this used? Answer: on WWW inventory-based zip code fields (http://test.national.aws.buyatoyota.com/en/camry/inventory/)
    // _this.initInventoryFormFMP(); // FMP version of initInventoryForm
    _this.initDealerForm();
  },

  initOffersForm: function () {
    $('.vehicle-discounts-zip-form, .vehicle-offers-discounts-zip-form').each(function (index, domElement) {
      var $this = $(this);

      $this.find('.btn').on('click', function (event) {
        event.preventDefault();

        var newZip = $this.find('input[type="text"]').val();
        var series = $this.find('input.vehicle-series').val();

        zipTools.changeZip(undefined, newZip, '/offers/' + series + '/', undefined, true);
      });
    });
  },

  // FMP version of initInventoryForm
  /* initInventoryFormFMP: function () {
    var $invForm = $('.vehicle-inventory-zip-form');
    var $invButton = $invForm.find('.btn');
    var newZip = $invForm.find('input[type="text"]').val();
    var series = $invForm.find('input.vehicle-series').val();
    var newUrl = '/inventory/results/?series=' + series;
    $invButton.attr('href', newUrl);

    $invButton.on('click', function () {
      window.fmp.removeDealerCookies();
      var currentZip = storageUtil.getZip();
      var newZip = $invForm.find('input[type="text"]').val();
      var newZipisValid = zipTools.isValidNewZip(currentZip, newZip);
      if (newZipisValid) {
        storageUtil.setZip(newZip);
        storageUtil.setConfirmedZip(true);
      }
    });

    window.fmp.attachInventoryClicks($invButton, newZip);
  }, */

  // NON-FMP version of initInventoryForm
  initInventoryForm: function () {
    $('.vehicle-inventory-zip-form').each(function (index, domElement) {
      var $this = $(this);

      $this.find('.btn').on('click', function (event) {
        event.preventDefault();

        var newZip = $this.find('input[type="text"]').val();
        var series = $this.find('input.vehicle-series').val();

        zipTools.changeZip(undefined, newZip, '/inventory/results/?series=' + series, undefined, true);
      });
    });
  },

  initDealerForm: function () {
    $('.find-dealer-zip-form').each(function () {
      var $this = $(this);
      $this.find('.btn').on('click', function (event) {
        event.preventDefault();
        var newZip = $this.find('input[type="tel"]').val();

        zipTools.changeZip(undefined, newZip, '/dealers/', function (newZip) {
          // if no TDA redirect occurs, go to find a dealer page
          var dealerPath = '/' + tdaConfig.site.context_url + '/dealers/';
          if (zipTools.redirectSETDealer) {
            dealerPath = 'http://southeast.buyatoyota.com/maps/expand?originating_zip_code=' + newZip;
          }
          window.location.href = dealerPath;
        }, true);
      });
    });
  }
};

export default {
  nationalLinks: nationalLinks,
  nationalForms: nationalForms
};
